import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useIsOverflowing } from '@cognite/cogs-utils';
import { Tooltip } from '../../tooltip/tooltip.js';

/**
 * A tooltip that only appears if the content is overflowing.
 */
var OverflowTooltip = function OverflowTooltip(props) {
  var contentRef = useRef(null);
  var children = props.children,
    rest = __rest(props, ["children"]);
  var isOverflowing = useIsOverflowing(contentRef, children);
  return jsx(Tooltip, Object.assign({
    wrapped: true,
    enterDelay: 500,
    enterNextDelay: 500,
    content: children,
    disabled: !isOverflowing
  }, rest, {
    children: jsx("div", {
      className: "cogs-v10 cogs-overflow-tooltip__content",
      ref: contentRef,
      children: children
    })
  }));
};

export { OverflowTooltip };
